import { Breadcrumbs } from 'components/bredcrambs';
import { BreadcrumbsProps } from 'constants/routes-breadcrumbs';

import styles from './styles.module.css';

export const HeaderCollection = ({ items }: { items: BreadcrumbsProps[] }) => {
  return (
    <div className={styles.container}>
      <Breadcrumbs items={items} />
    </div>
  );
};
